<template>

  <ion-grid>
    <ion-row>

      <ion-col size="auto">
        <h2>
          Expertise
        </h2>
      </ion-col>

      <ion-col>
        <ul>
          <li>Big Data (e.g. Apache-Spark, SQL, Snowflake)</li>
          <li>Machine Learning Model (e.g Linear Regression, Gradient Boosting Trees)</li>
          <li>Deep Learning Model (e.g Tensorflow)</li>
          <li>Machine Learning Model Deployment (e.g. Batch, REST-API)</li>
          <li>Machine Learning Model Monitoring (e.g. Concept Drift, Metric Drift)</li>
        </ul>
      </ion-col>

      <ion-col>
        <ul>
          <li>Web API Development (e.g. REST, GraphQL)</li>
          <li>Web API Deployment (e.g. Kubernetes, Heroku)</li>
          <li>Web API Monitoring (e.g. Promethus)</li>
          <li>Software Development Principles (e.g. KISS, DRY, Single Responsbility, Immutability)</li>
          <li>Software Design (e.g. Object Oriented Design, Functional Programming)</li>
        </ul>
      </ion-col>

    </ion-row>
  </ion-grid>

</template>

<script>

import { IonRow, IonCol, IonGrid } from '@ionic/vue';

export default {
  name: 'Expertise',
  components: {
    IonRow,
    IonCol,
    IonGrid
  }
}
</script>
